<div class="cart-wrapper">
    <a (click)="goToCheckout()">
        <span class="drg-icon-shopping_cart"></span>
        <span *ngIf="itemsNumber$ | async" class="number">{{ itemsNumber$ | async }}</span>
    </a>
</div>
